import { abortCalendarRequest } from "services/calendarRequestDiagnostics";
export const createLatestRequestCoordinator = () => {
  const requests = new Map();

  const forget = (key, request) => {
    if (requests.get(key) === request) {
      requests.delete(key);
    }
  };

  return {
    run(key, startRequest) {
      const previous = requests.get(key);
      if (previous && typeof previous.abort === "function") {
        abortCalendarRequest(previous, "superseded");
      }
      const request = startRequest();
      requests.set(key, request);
      Promise.resolve(request).then(
        () => forget(key, request),
        () => forget(key, request),
      );
      return request;
    },

    cancelOwner(owner) {
      const prefix = `${owner}:`;
      for (const [key, request] of requests.entries()) {
        if (!key.startsWith(prefix)) continue;
        if (request && typeof request.abort === "function") {
          abortCalendarRequest(request, "unmount");
        }
        requests.delete(key);
      }
    },
  };
};

export const calendarAvailabilityRequests = createLatestRequestCoordinator();

export const availabilityRequestLane = (values = {}) => {
  const owner = normalizeCalendarFormIdentity(values).owner;
  const lane = values.availableBusyTime || "time";
  return `${owner}:${lane}`;
};
import { normalizeCalendarFormIdentity } from "./calendarFormIdentity";
